<script>
import { mapState } from 'pinia';
import { orderStore } from '../../../stores/order';
import { langFunction as getLang } from '../../utils/langFunction';
import PersonalTabs from '../tabs/PersonalTabs.vue';

export default {
	components: {
		PersonalTabs
	},

	inject: ['debugMode'],

	data() {
		return {
			formValidateObject: null,
		};
	},

	computed: {
		...mapState(orderStore, ['personTypes']),
		...mapState(orderStore, {selectedPersonType: store => store.currentPersonType}),
	},

	mounted() {
		if (this.debugMode) console.log('personal mounted');
	},

	methods: {
		getLang
	},
};
</script>

<template>
	<div
		id="bx-soa-properties-personal"
		class="checkout-buyer checkout-item"
	>
		<h3 class="checkout-item__title">{{ $loc.get('PERSONAL_TITLE') }}</h3>
		<div class="checkout-item__wrapper">
			
			<template v-if="personTypes.length > 1">
				<PersonalTabs />
			</template>
			
			<input type="hidden" name="PERSON_TYPE" :value="selectedPersonType?.id">
		</div>
	</div>
</template>
